module.exports = __webpack_public_path__ + "img/14.6011f1b8.jpg";